import { forEach, isEmpty, get, startsWith } from 'lodash';
import {
  DEFAULT_LOW_BAL,
  DEFAULT_HIGH_BAL,
  SWEEP_ERROR_STATUS,
  UPGRADE_THRESHOLD_AMOUNT,
  AMOUNT_LIMIT,
} from '../constants/StringConstants';

export const getSavingAccounts = (accountList) => {
  const savingAccountList = [];
  forEach(accountList, (accounts) => {
    if (accounts.actions_available['/account/sweeps/transfer/out']) {
      savingAccountList.push(accounts);
    }
  });
  return savingAccountList;
};
export const getSweepsAccountData = (sweepState, sweepList) => {
  const sweepBalance = [
    {
      enabled: false,
      other_account_id: '',
      target: { value: DEFAULT_HIGH_BAL },
      threshold: { value: DEFAULT_LOW_BAL },
    },
  ];
  if (sweepState) {
    const { sweeps } = sweepList.get('sweepList');
    if (!isEmpty(sweeps)) {
      return sweeps;
    }
  }
  return sweepBalance;
};
export const checkSweepErrorStatus = (sweepList) => {
  const sweepErrorCode = sweepList.get('sweepError');
  return !(sweepErrorCode.status === SWEEP_ERROR_STATUS);
};
export const validateTargetAmount = (thresholdAmount, amount) => {
  const newThresholdValue = parseFloat(parseFloat(thresholdAmount) + UPGRADE_THRESHOLD_AMOUNT);
  if (newThresholdValue > parseFloat(amount) || !amount.length || startsWith(amount, '.')) {
    return true;
  }
  return false;
};
export const updateThresholdAmount = (targetAmount, amount) => {
  const targetdValue = parseFloat(targetAmount);
  const newTargetValue = parseFloat(parseFloat(amount) + UPGRADE_THRESHOLD_AMOUNT);
  if (
    targetdValue < newTargetValue &&
    parseFloat(amount) <= AMOUNT_LIMIT - UPGRADE_THRESHOLD_AMOUNT
  ) {
    return newTargetValue;
  }
  return false;
};
export const validateThresholdAmount = (amount) => {
  return parseFloat(amount) <= AMOUNT_LIMIT - UPGRADE_THRESHOLD_AMOUNT;
};
export const setSavingAccountID = (savingsAccountID, sweeps) => {
  if (isEmpty(savingsAccountID)) {
    return get(sweeps[0], 'other_account_id', '');
  }
  return savingsAccountID;
};
